export const APP_BASE_ROUTE = `/${process.env.REACT_APP_BASE_ROUTE}/`;

export const ROUTE_LANDING = "/";

export const ROUTE_SEARCH_STOPS = "/search-stops";
export const ROUTE_STOP_INFO_SQUARE = "/bus-stop-square/:id";
